import { initializeAnalytics } from '~/composables/analytics'
import { UserModule } from '~/types/app'

export const install: UserModule = ({ router }) => {
  initializeAnalytics(router)
}
